/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.Vue = require('vue').default;
window.Vue.use(require('vue-cookies'));
window.MobileDetect = require('mobile-detect');

import Filters from './filters';
import CollapsibleButton from './services/collapsible/CollapsibleButton';
import Collapsible from './services/collapsible/Collapsible';
import TableResponsive from './services/table_responsive/TableResponsive';
import {DebugBar, NewsletterForm, PromoCards} from '@kaxmedia/vuejs-components';

window.Vue.use(Filters);

window.hasLoadedMetabet = false;

/**
 * Define global variables and objects available for all VUE instances
 */
window.Vue.mixin({
    data() {
        return {
            INSTANCE: {
                MobileDetect: new MobileDetect(window.navigator.userAgent),
            },
            SUPPORTS_TOUCH: 'ontouchstart' in window || navigator.msMaxTouchPoints,
        };
    },
    mounted() {
        let metabetEl = document.getElementsByClassName('metabet-odds-board');

        // Ensure metabet widget loads once after Vue instance has mounted
        if (
            typeof mb_DOMContentLoaded === 'function' &&
            metabetEl.length !== 0 &&
            !window.hasLoadedMetabet
        ) {
            window.hasLoadedMetabet = true;
            localStorage.removeItem('metabet-location');
            mb_DOMContentLoaded();
        }
    },
});

require('./bootstrap');
require('es6-promise').polyfill();

//global.$ = global.jQuery= require('jquery');
require('select2');
require('./select2-factory');
require('slick-carousel');
require('./core');
require('./globalnav');
require('./ip-redirect');
require('./bookmark');

global.CollapsibleButton = CollapsibleButton;

global.Collapsible = Collapsible;

new TableResponsive().init();

Vue.component('promo-cards', PromoCards);

Vue.component('newsletter-form', NewsletterForm);
Vue.component('subscription-form', require('./components/subscription/SubscriptionForm').default);
Vue.component('signup-form', require('./components/signupForm/SignUpForm.vue').default);
Vue.component('oplist-signup-form', require('./components/signupForm/OplistSignupForm.vue').default);
Vue.component('fake-checkbox', require('./components/FakeCheckboxComponent.vue').default);
Vue.component('select2', require('./components/Select2.vue').default);
Vue.component('loading-spinner', require('./components/LoadingSpinner.vue').default);
Vue.component('region-selector', require('./components/RegionSelector').default);
Vue.component('single-offer', require('./components/operator_list/SingleOffer.vue').default);
Vue.component('popup-offer', require('@RESOURCES/js/components/operator_list/PopupOffer.vue').default);
Vue.component('payment-methods-table', require('./components/PaymentMethodsTable.vue').default);
Vue.component('no-state-offer', require('./components/operator_list/NoStateOffer.vue').default);
Vue.component('brand-list', require('./components/brand/list/BrandList').default);
Vue.component('us-brand-offer-table', require('./components/brand/table/USBrandOfferTable').default);
Vue.component('payments-table', require('./components/PaymentProvidersTableComponent.vue').default);
Vue.component('state-exit-link-button', require('./components/brand/content/StateExitLinkButton').default);
Vue.component('exit-link-button-elements', require('./components/operator_list/ExitLinkButtonElements').default);
Vue.component('slot-games-list', require('./components/SlotGames/SlotGamesList').default);
Vue.component('slot-game-item', require('./components/SlotGames/SlotGameItem').default);
Vue.component('slot-game-filters', require('./components/SlotGames/SlotGameFilters').default);
Vue.component('autocomplete', require('./components/Autocomplete').default);
Vue.component('progressive-jackpots', require('./components/ProgressiveJackpots/ProgressiveJackpots').default);
Vue.component('trust-signal-groups', require('./components/TrustSignalGroups.vue').default);
Vue.component('product-coverage-table', require('./components/ProductCoverageTable').default);
Vue.component('pagination', require('./components/Pagination').default);
Vue.component('switch-button', require('./components/SwitchButton').default);
Vue.component('sort-by', require('./components/SortBy').default);
Vue.component('age-checker-gb', require('./components/age-checker/AgeCheckerGB.vue').default);
Vue.component('operator-list-tab', require('@RESOURCES/js/components/operator_list/OperatorListTab.vue').default);
Vue.component('team-stats', require('@RESOURCES/js/components/matrix/TeamStats.vue').default);
Vue.component('player-stats', require('@RESOURCES/js/components/matrix/PlayerStats.vue').default);
Vue.component('goal-stats', require('@RESOURCES/js/components/matrix/GoalStats.vue').default);
Vue.component('card-stats', require('@RESOURCES/js/components/matrix/CardStats.vue').default);
Vue.component('corner-stats', require('@RESOURCES/js/components/matrix/CornerStats.vue').default);
Vue.component('possession-stats', require('@RESOURCES/js/components/matrix/PossessionStats.vue').default);
Vue.component('show-more-show-less-button', require('@RESOURCES/js/components/operator_list/ShowMoreShowLessButton.vue').default);

//Articles
Vue.component('article-item', require('@RESOURCES/js/components/articles/ArticleItem.vue').default);
Vue.component('article-featured', require('@RESOURCES/js/components/articles/ArticleFeatured.vue').default);
Vue.component('articles-global', require('@RESOURCES/js/components/articles/ArticlesGlobal.vue').default);

if (document.getElementById('debug')) {
    new Vue({
        el: '#debug',
        components: {
            DebugBar,
        },
    });
}

if (document.getElementById('newsletter-form')) {
    new Vue({
        el: '#newsletter-form',
        components: {
            NewsletterForm,
        },
    });
}

if (document.getElementById('oplist')) {
    const operatorList = new Vue({
        el: '#oplist',
    });
}

Vue.component('global-search', require('./components/Search/GlobalSearch').default);
if (document.getElementsByClassName('global-search-container navigation').length > 0) {
    new Vue({el: ".global-search-container.navigation"})
}
if (document.getElementsByClassName('global-search-container home-banner').length > 0) {
    new Vue({el: ".global-search-container.home-banner"})
}
